//import 'ol/ol.css';
import { Map, Feature } from 'ol';
import { INode, FeatureType, ICAMSKey, TextPack } from '../Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities } from '../Utility/Utilities';
import * as events from '../Bus/Bus';

export class SelectListOptions {
    showDetailsBtn: boolean = true;
    showMapHighlightBtn: boolean = true;
    showMapEditBtn: boolean = true;
    showEditAttributeBtn: boolean = true;
    showAddSelectionBtn: boolean = false;
    showAnnotationBtn: boolean = false;
    showDeleteBtn: boolean = false;
}

export class SelectList {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;
    private featureInfoRequest: any;
    private selectListOptions: SelectListOptions;
    private textPackKeys: Record<string, string> = {
        CopyUrlTitleTextResult: "CopyUrlTitleTextResult"
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: Map, selectListOptions?: SelectListOptions) {
        if (selectListOptions != null) {
            this.selectListOptions = selectListOptions;
        }
        else {
            this.selectListOptions = new SelectListOptions();
        }
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        $('#selectListCloseBtn').on("click", function () {
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventResetAllButtons(true));
        });        
    }

    // ----------------------------------------------------------- //
    // SELECT LIST PANEL
    public openSelectListPanel = (input: { maintCodes: any[], infraCodes: any[], infraHistoricCodes: any[], routeCodes: any[], landCodes: any[], troGeomIDs: any[] }): void => {
        const self = this;
        self.featureInfoRequest = input; 

        // Load the modal form
        $('#selectListPanel').addClass('show');
        Utilities.BlockUI($('#selectListPanel'));
        $('#selectListContainer').load(window.G_SITEFOLDERNAME +'/SelectList/GetFeaturesSummary', { data: input }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                 window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI($('#selectListPanel'));

            self.postSelectListResult();
        });
    }

    public openSelectListMapPopup = (input: { maintCodes: any[], infraCodes: any[], infraHistoricCodes: any[], routeCodes: any[], landCodes: any[], troGeomIDs: any[] }, point: any): void => {
        const self = this;
        self.featureInfoRequest = input;
   
        // Load the modal form
        Utilities.BlockUI($('#mainMapPopup'));
        $('#mainMapPopupContainer').load(window.G_SITEFOLDERNAME +'/SelectList/GetFeaturesSummary', { data: input, point: point }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI($('#mainMapPopup'));

            $('.ol-popup').css('height', 'unset'); // unset the height so if only one feature returns, the popup auto sizes smaller

            self.postSelectListResult();
            $('#mainMapPopupContainer').scrollTop(0);
        });
    }

    private postSelectListResult = (): void => {
        const self = this;

        // Show issue comments
        $('[data-comment]').on("click", function () {
            const data: ICAMSKey = $(this).data("comment");
            events.bus.publish(events.eventOpenMaintCommentCreatePanel(data));
        });

        // MAP ZOOM BTN
        if (self.selectListOptions.showMapHighlightBtn == false) {
            $('[data-zoommap]').parent().remove();
        }
        else {
            $('[data-zoommap]').on("click", function () {
                const data: ICAMSKey = $(this).data("zoommap");
                events.bus.publish(events.eventZoomToAnyFeature([data, true, null]));
            });
        }
    
        // MAP EDIT BTN
        if (self.selectListOptions.showMapEditBtn == false) {
            $('[data-editmap]').parent().remove();
        }
        else {
            $('[data-editmap]').on("click", function () {
                const data: ICAMSKey = $(this).data("editmap");
                events.bus.publish(events.eventModifyFeature([data, true]));
            });
        }

        // EDIT BTN
        if (self.selectListOptions.showEditAttributeBtn == false) {
            $('[data-editatr]').parent().remove();
        }
        else {
            $('[data-editatr]').on("click", function () {
                const data: ICAMSKey = $(this).data("editatr");
                self.openEditPanel(data);
            });
        }

        // ADD BTN
        if (self.selectListOptions.showAddSelectionBtn == false) {
            $('[data-addatr]').parent().remove();
        }
        else {
            $('[data-addatr]').on("click", function () {
                const data: ICAMSKey = $(this).data("addatr");
                if (data.featureType == FeatureType.Maint) {
                    events.bus.publish(events.eventAddToSelection({ maintCodes: [data.code] }));
                }

                if (data.featureType == FeatureType.Infra) {
                    events.bus.publish(events.eventAddToSelection({ infraCodes: [data.code] }));
                }

                if (data.featureType == FeatureType.Route) {
                    events.bus.publish(events.eventAddToSelection({ routeCodes: [data.code] }));
                }

                if (data.featureType == FeatureType.Land) {
                    events.bus.publish(events.eventAddToSelection({ landCodes: [data.code] }));
                }

                if (data.featureType == FeatureType.TRO) {
                    events.bus.publish(events.eventAddToSelection({ troGeomIDs: [data.code] }));
                }

            });
        }

        // EDIT BTN
        if (self.selectListOptions.showAnnotationBtn == false) {
            $('[data-annatr]').parent().remove();
        }
        else {
            $('[data-annatr]').on("click", function () {
                const data: ICAMSKey = $(this).data("annatr");
                events.bus.publish(events.eventShowAnnotationsForFeature([data, true]));
            });
        }

        // DEL BTN
        if (self.selectListOptions.showDeleteBtn == false) {
            $('[data-delatr]').parent().remove();
        }
        else {
            $('[data-delatr]').on("click", function () {
                const data: ICAMSKey = $(this).data("delatr");
                self.deleteEntity(data);
            });
        }

        //Get any associated image from Librarylink
        $('[name="selectListPhotoContainer"]').each(function (index, element) {
            var myEl = $(this);
            events.bus.publish(events.eventPhotoCreatePhotoThumbnail([element, function (r) { if (r == true) myEl.css("display", "none"); }]));
        });

        // Link Copy
        $('[data-sharemaintlink]').on('click', function () {
            var link = $(this).data('sharemaintlink');
            self.copyToClipboard(link);

            const data: ICAMSKey = $(this).data("zoommap");
            events.bus.publish(events.eventZoomToAnyFeature([data, true, null]));
        });
        $('[data-shareinfralink]').on('click', function () {
            var link = $(this).data('shareinfralink');
            self.copyToClipboard(link);

            const data: ICAMSKey = $(this).data("zoommap");
            events.bus.publish(events.eventZoomToAnyFeature([data, true, null]));
        });
        $('[data-shareroutelink]').on('click', function () {
            var link = $(this).data('shareroutelink');
            self.copyToClipboard(link);

            const data: ICAMSKey = $(this).data("zoommap");
            events.bus.publish(events.eventZoomToAnyFeature([data, true, null]));
        });
        $('[data-sharelandlink]').on('click', function () {
            var link = $(this).data('sharelandlink');
            self.copyToClipboard(link);
          
            const data: ICAMSKey = $(this).data("zoommap");
            events.bus.publish(events.eventZoomToAnyFeature([data, true, null]));
        });
        
    }

    public reRunLastInfoRequest = (): void => {
        this.openSelectListPanel(this.featureInfoRequest);
    }

    // ----------------------------------------------------------- //
    // EDIT PANEL
    public openEditPanel = (data: ICAMSKey): void => {
        if (data.featureType == FeatureType.Maint) {
            events.bus.publish(events.eventOpenMaintEditPanel(data));
        }

        if (data.featureType == FeatureType.Infra) {
            events.bus.publish(events.eventOpenInfraEditPanel([data,null]));
        }

        if (data.featureType == FeatureType.InfraHistoric) {
            events.bus.publish(events.eventOpenInfraHistoricDetailsPanel([data, null]));
        }

        if (data.featureType == FeatureType.Route) {
            events.bus.publish(events.eventOpenRouteEditPanel(data));
        }

        if (data.featureType == FeatureType.Path) {
            events.bus.publish(events.eventOpenPathEditPanel(data));
        }

        if (data.featureType == FeatureType.Land) {
            events.bus.publish(events.eventOpenLandEditPanel(data));
        }

        if (data.featureType == FeatureType.TRO) {
            events.bus.publish(events.eventOpenTROGeomEditPanel(data));
        }

        if (data.featureType == FeatureType.LegalEvent) {
            events.bus.publish(events.eventOpenLegalEventsEditPanel(data));
        }

        if (data.featureType == FeatureType.LegalFeature) {
            events.bus.publish(events.eventOpenLegalEventsEditPanelViaLegalFeature(data.code));
        }
    }

    public setVisibleButtons = (selectListOptions: SelectListOptions): void => {
        this.selectListOptions = selectListOptions;
    }

    public deleteEntity = (data: ICAMSKey): void => {
        if (data.featureType == FeatureType.Maint) {
            events.bus.publish(events.eventDeleteMaint(data));
        }
        else if (data.featureType == FeatureType.Route) {
            events.bus.publish(events.eventDeleteRoute(data));
        }
        else if (data.featureType == FeatureType.Infra) {
            events.bus.publish(events.eventDeleteInfra([data, null]));
        }
        else if (data.featureType == FeatureType.Land) {
            events.bus.publish(events.eventDeleteLand(data));
        }
        else if (data.featureType == FeatureType.TRO) {
            events.bus.publish(events.eventDeleteTROGeom(data));
        }

    }

    private copyToClipboard = (comment: string): void => {
        var self = this;
        (navigator as any).clipboard.writeText(comment).then(() => {
            Utilities.GetTranslations([{ textPack: TextPack.SelectListTextPack, key: self.textPackKeys.CopyUrlTitleTextResult }]).then(function (r) { toastr.info(r.data[0].value); }).catch(function (e) { console.log(e); });
            //toastr.info("Copied link to clipboard!");
        }, () => {
            toastr.error("Failed to copy link to clipboard!");
        });
    }
}




